const keys = {
  moeda: {
    description: 'Moeda',
    isEnum: true,
    enumName: 'Moeda',
  },
  'prazoPagamento.descricao': {
    description: 'Prazo de pagamento',
  },
  total: {
    description: 'Total',
    isCurrency: true,
  },
  totalProdutos: {
    description: 'Total produtos',
    isCurrency: true,
  },
  valorFrete: {
    description: 'Valor sem ICMS',
    isCurrency: true,
  },
  formaPagamento: {
    description: 'Forma de pagamento',
    isEnum: true,
    enumName: 'FormaPagamento',
  },
  prazoEntrega: {
    description: 'Prazo de entrega',
  },
  observacao: {
    description: 'Observação',
  },
  icms: {
    description: 'ICMS',
    isFloat: true,
    type: 'PERCENTUAL',
    suffix: ' %',
  },
  tipoAplicacaoIcms: {
    description: 'Aplicação ICMS',
    isEnum: true,
    enumName: 'AplicacaoImposto',
  },
  finalizado: {
    description: 'Finalizado',
    isBoolean: true,
  },
  statusNegociacao: {
    description: 'Status negociação',
    isStatusNegociacao: true,
  },
  validade: {
    description: 'Validade',
    isDate: true,
  },
  'frete.ofertaFreteGratis': {
    description: 'Oferece frete grátis',
    isBoolean: true,
  },
  'frete.valorMinimoFreteGratis': {
    description: 'Valor mínimo frete grátis',
    isCurrency: true,
  },
  'frete.tipoFrete': {
    description: 'Tipo frete',
    isEnum: true,
    enumName: 'TipoFrete',
  },
  'frete.prazoEntrega': {
    description: 'Prazo entrega',
  },
  'frete.totalTransporte': {
    description: 'Total transporte',
    isCurrency: true,
  },
  'frete.observacaoFrete': {
    description: 'Observação frete',
  },
  'produto.situacao': {
    description: 'Situação',
    isEnum: true,
    enumName: 'SituacaoRespostaCotacaoProduto',
  },
  'produto.finalizado': {
    description: 'Finalizado',
    isBoolean: true,
  },
  'produto.compra': {
    description: 'Compra',
    isBoolean: true,
  },
  'produto.precoUnitario': {
    description: 'Preço unitário',
    isCurrency: true,
  },
  'produto.totalProdutos': {
    description: 'Total produtos',
    isCurrency: true,
  },
  'produto.total': {
    description: 'Total',
    isCurrency: true,
  },
  'produto.impostos.frete': {
    description: 'Frete',
    isCurrency: true,
  },
  'produto.impostos.icms': {
    description: 'ICMS',
    isFloat: true,
    type: 'PERCENTUAL',
    suffix: ' %',
  },
  'produto.impostos.ipi': {
    description: 'IPI',
    isFloat: true,
    type: 'PERCENTUAL',
    suffix: ' %',
  },
};

const values = Object.keys(keys)
  .map(key => keys[key]);

export default {
  keys,
  values,
};
